import {Component, computed, inject, ChangeDetectionStrategy} from "@angular/core"
import {RouterOutlet} from "@angular/router"
import {CheckboxesFilterComponent, SearchFilterComponent, TagSearchFilterComponent} from "@common/components/filters"
import {ItemFiltersComponent} from "@common/components/item"
import {SidebarLayoutComponent} from "@platform/components/layouts/sidebar-layout/sidebar-layout.component"
import {AddTagDialogComponent} from "@platform/components/tags/add-tag-dialog/add-tag-dialog.component"
import {TagsTableComponent} from "@platform/components/tags/tags-table/tags-table.component"
import {CreateItemComponent} from "@common/components/base/create-item.component"
import {PermissionsService} from "@common/services/permissions/permissions.service"
import {RefreshService} from "@common/services/refresh/refresh.service"
import {ContentTypeModel} from "@generated"
import {Labels} from "@platform/models/state-labels"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CheckboxesFilterComponent,
        ItemFiltersComponent,
        RouterOutlet,
        SearchFilterComponent,
        TagSearchFilterComponent,
        TagsTableComponent,
        SidebarLayoutComponent,
    ],
    selector: "cm-tags-page",
    styleUrls: ["./tags-page.component.scss"],
    templateUrl: "./tags-page.component.html",
})
export class TagsPageComponent extends CreateItemComponent<AddTagDialogComponent> {
    readonly permission = inject(PermissionsService)
    readonly refresh = inject(RefreshService)

    readonly $tagTypes = computed(() => Array.from(Labels.TagType.values()).filter((label) => this.permission.$to().read.tagType(label.state)))

    protected openCreateDialog() {
        const dialogRef = this.dialog.open(AddTagDialogComponent, {
            data: {},
        })
        this.setDialogRef(dialogRef)
    }

    protected override handleDialogResult(result: unknown): boolean | void {
        const tag = result as {id: string} | undefined
        if (tag?.id) {
            // Trigger refresh of the tags list to show the newly created tag
            this.refresh.contentTypeModel(ContentTypeModel.Tag)

            // Navigate to the created tag details
            void this.router.navigate([tag.id], {
                relativeTo: this.route,
                queryParamsHandling: "preserve",
            })
            // Return false to skip default navigation
            return false
        }
    }
}
